import { Settings } from 'luxon';
import Vue from 'vue';
import { Datetime } from 'vue-datetime';

Vue.component('dateTime', Datetime);

export default Settings;
